import { useTranslation } from 'react-i18next';

function FlagIcon({ lang }) {
  const size = 18;

  if (lang === 'th') {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block', borderRadius: 3, flexShrink: 0 }}>
        <rect width="24" height="24" fill="#ED1C24" />
        <rect y="4" width="24" height="16" fill="#FFFFFF" />
        <rect y="8" width="24" height="8" fill="#241D4F" />
      </svg>
    );
  }

  // EN → US flag (simple)
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ display: 'block', borderRadius: 3, flexShrink: 0 }}>
      <rect width="24" height="24" fill="#B22234" />
      <rect y="2.4" width="24" height="2.4" fill="#FFFFFF" />
      <rect y="7.2" width="24" height="2.4" fill="#FFFFFF" />
      <rect y="12" width="24" height="2.4" fill="#FFFFFF" />
      <rect y="16.8" width="24" height="2.4" fill="#FFFFFF" />
      <rect y="21.6" width="24" height="2.4" fill="#FFFFFF" />
      <rect width="10" height="12" fill="#3C3B6E" />
    </svg>
  );
}

export default function LanguageSwitcher({ style = {}, variant = 'default' }) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.split('-')[0] || 'th';

  const toggleLanguage = () => {
    const newLang = currentLang === 'th' ? 'en' : 'th';
    i18n.changeLanguage(newLang);
  };

  // Button style for sidebar
  const baseStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 16px',
    borderRadius: 12,
    border: '2px solid #e2e8f0',
    fontSize: 14,
    fontWeight: 600,
    backgroundColor: '#fff',
    color: '#1e40af',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease',
    boxShadow: '0 2px 8px rgba(30,64,175,0.08)',
    ...style
  };

  // Button style for navbar
  const navStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 16px',
    borderRadius: 999,
    border: '2px solid rgba(255,255,255,0.3)',
    fontSize: 13,
    fontWeight: 600,
    background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
    color: '#fff',
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease',
    backdropFilter: 'blur(4px)',
    ...style
  };

  const currentStyle = variant === 'nav' ? navStyle : baseStyle;

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      style={currentStyle}
      aria-label={currentLang === 'th' ? 'Switch to English' : 'Switch to Thai'}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
        if (variant === 'nav') {
          e.currentTarget.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.15) 100%)';
        } else {
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(30,64,175,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        if (variant === 'nav') {
          e.currentTarget.style.background = 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)';
        } else {
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(30,64,175,0.08)';
        }
      }}
    >
      <FlagIcon lang={currentLang} />
      <span>{currentLang === 'th' ? 'TH' : 'EN'}</span>
    </button>
  );
}
